import { cn } from "@/lib/utils";
import { HugeiconsIcon } from "@hugeicons/react";
import { ChevronRightIcon } from "@/components/ui/icons";
import { CheckmarkSquare03Icon } from "@hugeicons/core-free-icons";
import type { SearchOptionProps } from "./types";

export const TasksOption = ({
  option,
  isSelected,
  onClick,
}: SearchOptionProps) => {
  return (
    <div
      onClick={onClick}
      className={cn(
        "flex items-center gap-3 px-4 py-3 cursor-pointer hover:bg-accent transition-colors",
        isSelected && "bg-primary/10 text-primary!"
      )}
    >
      <div className="flex items-center gap-1">
        <div
          className={cn(
            "flex size-8 items-center justify-center rounded-md border",
            isSelected && "border-primary text-primary!"
          )}
        >
          <HugeiconsIcon icon={CheckmarkSquare03Icon} size={16} />
        </div>
      </div>
      <div className="text-sm font-medium">Go to Tasks</div>
      <HugeiconsIcon icon={ChevronRightIcon} size={16} />
      <div className="flex-1 truncate text-sm font-medium">{option.title}</div>
    </div>
  );
};
